import React, { useEffect, useState } from "react";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import { ClientUser } from "shared/models/interfaces/client-user.interface";
import EditProfileForm from "@components/forms/edit-profile-form";
import { ModalMessage } from "@components/message-modal";
import styled from "@emotion/styled";
import UserSettingsLayout from "shared/layouts/user-settings";
import { en,es} from "@lang"

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

function EditProfile(props: any) {
  const titleT = useTranslations("title-pages");
  const t = useTranslations("ProfileEdit");
  const router = useRouter();
  const _user = useAppSelector((state) => state.Auth.user);
  const [localUser, setLocalUser] = useState<ClientUser | null>(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  useEffect(() => {
    setLocalUser(_user);
    if (!_user) router.push(CPagesPath.es.signin);
  }, [_user, router]);

  if (!localUser) return null;

  const onSubmitSuccess = () => setShowSuccessAlert(true);

  return (
    <>
      <Head>
        <title>{titleT("profile-edit")}</title>
      </Head>
      <Container>
        <PageTitle>{t("title")}</PageTitle>
        <EditProfileForm user={localUser} onSubmitSuccess={onSubmitSuccess} />
        <SuccessModal open={showSuccessAlert} />
      </Container>
    </>
  );
}

interface ISuccessModal {
  open: boolean;
}

function SuccessModal({ open }: ISuccessModal) {
  const t = useTranslations("ProfileEdit.success");
  const router = useRouter();

  return (
    <ModalMessage
      open={open}
      title={t("title")}
      body={t("message")}
      handleClose={() => router.push(CPagesPath.es.profile)}
      buttonText={t("link")}
    />
  );
}

EditProfile.Layout = UserSettingsLayout;
export default EditProfile;

const PageTitle = styled.h1`
  color: var(--color-brand-blue-main);
  font-weight: 500;
  margin-bottom: 30px;
`;

const Container = styled.section`
  max-width: 820px;
  margin: auto;
  padding: 30px 20px;
`;
